// extracted by mini-css-extract-plugin
export default {"container":"FilterTable_container__CpU14","highlight":"FilterTable_highlight__0teMG","levelLabel":"FilterTable_levelLabel__zdkV6","arrow":"FilterTable_arrow__NPhty"};